export const consultantKnowledgeArticle = {
  title: 'AI Business Consultant: Knowledge Base',
  slug: 'consultant-knowledge',
  content: `AI Business Consultant: Knowledge Base

Upload documents so the consultant can reference them in conversations.

1) Upload documents
- Open the Knowledge tab.
- Click “Upload Document” or drag-and-drop files into the drop zone.

2) Supported file types
- PDF, Word, Excel, TXT, and Markdown files are supported.
- Files larger than 10MB are rejected.

3) Organization by business
- If a business is selected, uploads are scoped to that business.
- The AI prioritizes documents matching the active business.

4) Manage documents
- Download or delete files from the list at the bottom of the tab.
`,
};
